"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zilpay = void 0;
const util_1 = require("../../util");
const constant_1 = require("../../constant");
class Zilpay {
    constructor(network) {
        this.network = network;
        this.blockchain = util_1.BlockchainUtils.Blockchain.Zilliqa;
    }
    static getNetworkParams(network) {
        if (network === constant_1.Network.MainNet) {
            // currently zilpay only used by zilliqa
            return {
                chainId: Number(1),
                chainname: 'Zilliqa Mainnet',
                rpcUrl: 'https://api.zilliqa.com'
            };
        }
        if (network == constant_1.Network.DevNet) {
            return {
                chainId: Number(999),
                chainname: 'Zilliqa Devnet',
                rpcUrl: 'https://poly-api.zilliqa.com'
            };
        }
        return {
            chainId: Number(333),
            chainname: 'Zilliqa Testnet',
            rpcUrl: 'https://dev-api.zilliqa.com'
        };
    }
    static getRequiredChainId(network) {
        if (network === constant_1.Network.MainNet) {
            return 1;
        }
        if (network === constant_1.Network.DevNet) {
            return 888;
        }
        // Testnet
        return 333;
    }
    getBlockchain() {
        return this.blockchain;
    }
    getSigner() {
        return __awaiter(this, void 0, void 0, function* () {
            const zil = yield this.getConnectedAPI();
            if (!zil) {
                throw new Error('ZilPay not connected, please check that your extension is enabled');
            }
            return zil.wallet;
        });
    }
    getConnectedAPI() {
        return __awaiter(this, void 0, void 0, function* () {
            const zilPayAPI = this.getAPI();
            if (!zilPayAPI) {
                throw new Error('ZilPay not connected, please check that your extension is enabled');
            }
            const isConnect = yield zilPayAPI.wallet.connect();
            if (!isConnect) {
                throw new Error('user reject');
            }
            return this.getAPI();
        });
    }
    getAPI() {
        var _a;
        return (_a = window.zilPay) !== null && _a !== void 0 ? _a : null;
    }
}
exports.Zilpay = Zilpay;
